import React from 'react';

export default function PageFooter() {
  return (
    <div id="footer">
      <p>&copy;2019 David Yao. All rights reserved.</p>
    </div>
  );
}
